import React from 'react';
import PropTypes from 'prop-types';
import { st, classes, vars } from './SkeletonGroup.st.css.js';
import { SkeletonGroupContext } from './SkeletonGroupAPI';
/** SkeletonGroup */
function SkeletonGroup({ dataHook, className, skin = 'light', children, backgroundColor, }) {
    return (React.createElement("div", { "data-hook": dataHook, className: st(classes.root, className), style: {
            [vars['color']]: backgroundColor,
        }, "data-status": "loading" },
        React.createElement(SkeletonGroupContext.Provider, { value: { skin } }, children),
        React.createElement("div", { className: classes.animator })));
}
SkeletonGroup.displayName = 'SkeletonGroup';
SkeletonGroup.propTypes = {
    dataHook: PropTypes.string,
    className: PropTypes.string,
    skin: PropTypes.oneOf(['dark', 'light']),
    backgroundColor: PropTypes.string,
};
export default SkeletonGroup;
//# sourceMappingURL=SkeletonGroup.js.map